// extracted by mini-css-extract-plugin
module.exports = {"landing-container":"landing-container_o2vs","tech-eg":"tech-eg_3hbo","eg-list":"eg-list_1QQp","eg-item":"eg-item_3BP7","txt":"txt_EJQj"};